/**
 * Scroll Animation Module
 * 범용 스크롤 애니메이션 기능
 * 사용법: data-animate="fade-up" 같은 속성을 요소에 추가
 * 페이지 로드 시 즉시 실행: data-is-page-load="true" 추가
 */

if (typeof window.initScrollAnimate === 'undefined') {
  window.initScrollAnimate = function(container = document) {
    // 애니메이션 타입별 초기 스타일 정의
    const animationStyles = {
      'fade-up': {
        opacity: 0,
        transform: 'translateY(2rem)'
      },
      'fade-down': {
        opacity: 0,
        transform: 'translateY(-2rem)'
      },
      'fade-left': {
        opacity: 0,
        transform: 'translateX(2rem)'
      },
      'fade-right': {
        opacity: 0,
        transform: 'translateX(-2rem)'
      },
      'fade': {
        opacity: 0
      },
      'scale': {
        opacity: 0,
        transform: 'scale(0.9)'
      },
      'zoom-in': {
        opacity: 0,
        transform: 'scale(0.8)'
      }
    };

    // 애니메이션 타입별 최종 스타일
    const finalStyles = {
      opacity: 1,
      transform: 'translate(0, 0) scale(1)'
    };

    // 애니메이션 대상 요소 선택
    const animatedElements = container.querySelectorAll('[data-animate]');

    if (animatedElements.length === 0) return;

    // Intersection Observer 옵션
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    // 애니메이션 실행 함수
    const triggerAnimation = (element) => {
      const animationType = element.dataset.animate || 'fade';
      let delay = parseInt(element.dataset.animateDelay) || 0;
      const duration = parseInt(element.dataset.animateDuration) || 800;

      // 공통 변수가 있으면 기본 지연 시간 추가
      if (window.ANIMATION_CONFIG) {
        delay = delay + window.ANIMATION_CONFIG.DEFAULT_DELAY + window.ANIMATION_CONFIG.DEFAULT_DURATION;
      }

      setTimeout(() => {
        element.classList.add('animate-in');
      }, delay);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;
          triggerAnimation(element);
          observer.unobserve(element); // 한 번만 실행
        }
      });
    }, observerOptions);

    // 각 요소 초기화 및 관찰 시작
    animatedElements.forEach(el => {
      const animationType = el.dataset.animate || 'fade';
      const duration = parseInt(el.dataset.animateDuration) || 800;
      const isPageLoad = el.dataset.isPageLoad === 'true';
      const initialStyle = animationStyles[animationType] || animationStyles['fade'];

      // 초기 상태 설정
      el.classList.add('animate-ready');
      el.style.opacity = initialStyle.opacity || '0';
      if (initialStyle.transform) {
        el.style.transform = initialStyle.transform;
      }
      el.style.transition = `opacity ${duration}ms ease, transform ${duration}ms ease`;

      // 페이지 로드 시 즉시 실행 옵션이 있으면 Observer에 등록하지 않고 바로 실행
      if (isPageLoad) {
        triggerAnimation(el);
      } else {
        observer.observe(el);
      }
    });
  };
}

// DOM이 로드되면 초기화
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.initScrollAnimate();
  });
} else {
  window.initScrollAnimate();
}

// SPA 페이지 전환 시 재초기화를 위한 함수 (common.js의 executeScripts와 연동)
if (typeof window.reinitScrollAnimate === 'undefined') {
  window.reinitScrollAnimate = function(container) {
    window.initScrollAnimate(container);
  };
}